import { PRICE_SELECTED } from 'shared/data/quoteSteps';

export const buildAssemblyData = (arg) => {
  const {
    quoteStep,
    assemblyVariant,
    parameters,
    zip_file_input_id,
    project_number,
    project_reference,
    fabrication_quote,
  } = arg;
  if (quoteStep !== PRICE_SELECTED) return null;

  const form = new FormData();
  form.append('parameters[project_number]', project_number);
  form.append('parameters[project_reference]', project_reference);
  form.append('variant_id', assemblyVariant);

  // If the user comes from a quote from Viewmate, we need to tell
  // the backend what the fabrication quote is so we can take the file from it
  if (fabrication_quote) {
    form.append('fabrication_quote', fabrication_quote);
  }

  Object.keys(parameters).forEach((key) => {
    if (key === 'quantities') {
      parameters[key].forEach((qty) => {
        form.append(`parameters[${key}][]`, qty);
      });
    } else {
      form.append(`parameters[${key}]`, parameters[key]);
    }
  });

  const input_file = document.querySelector(`#${zip_file_input_id}`);
  const file = input_file ? input_file.files[0] : null;

  // If the file is present, it means the user wants to add a new file or replace it for this line item,
  // else we should not send the filename parameter or it will be unlinked in the backend
  if (file) {
    form.append('parameters[filename]', file);
  } else {
    form.delete('parameters[filename]');
  };

  return form;
};

export const buildForms = (args) => {
  if (!args) return [];
  const assemblyForm = buildAssemblyData(args);
  return assemblyForm ? [assemblyForm] : [];
};
